import React from 'react';
import clsx from 'clsx';
import { Group, Text, Stack } from '@mantine/core';
import { IconMapPin } from '@tabler/icons-react';
import { FONT_WEIGHT_SEMIBOLD } from '@/constants/ui';
import type { TaskDetailsHeaderProps } from './TaskDetailsHeader.types';
import { formatCoordinates } from '../../../../utils/helpers';
import styles from './TaskDetailsHeader.module.css';

export const TaskDetailsHeader: React.FC<TaskDetailsHeaderProps> = React.memo(
  ({ task, className }) => {
    const coordinates = task.anchorPoint ?? { lat: 0, lng: 0 };

    return (
      <Stack gap="2xs" className={clsx(styles.titleStack, className)}>
        <Text
          size="lg"
          fw={FONT_WEIGHT_SEMIBOLD}
          lineClamp={2}
          className={styles.title}
        >
          {task.title}
        </Text>

        <Group gap="2xs" className={styles.locationGroup}>
          <IconMapPin size={12} className={styles.locationIcon} />
          {task.location ? (
            <>
              <Text size="xs" c="dimmed" className={styles.roadName}>
                {task.location}
              </Text>
              <Text
                size="xs"
                c="dimmed"
                ff="monospace"
                className={styles.coordinates}
              >
                {formatCoordinates(coordinates.lat, coordinates.lng)}
              </Text>
            </>
          ) : (
            <Text
              size="xs"
              c="dimmed"
              ff="monospace"
              className={styles.coordinates}
            >
              {formatCoordinates(coordinates.lat, coordinates.lng)}
            </Text>
          )}
        </Group>
      </Stack>
    );
  }
);
